module.exports = __webpack_public_path__ + "img/D201902_2.e90c81ed.jpg";